"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var headers_exports = {};
__export(headers_exports, {
  authHeaders: () => authHeaders,
  combineHeaders: () => combineHeaders,
  formatClientHeader: () => formatClientHeader,
  jsonHeaders: () => jsonHeaders
});
module.exports = __toCommonJS(headers_exports);
var import_types = require("@cartographerio/types");
function authHeaders({ client }, auth) {
  const ans = {};
  if (client != null) {
    const clientHeader = formatClientHeader(client);
    ans["Cartographer-Client"] = clientHeader;
    if (client.overrideUserAgent) {
      ans["User-Agent"] = clientHeader;
    }
  }
  if (auth != null) {
    ans["Authorization"] = (0, import_types.authHeader)(auth);
  }
  return ans;
}
const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json"
};
function combineHeaders(...headers) {
  return headers.reduce((a, b) => ({ ...a, ...b }), {});
}
function formatClientHeader(client) {
  const { name, version, build, hints } = client;
  let ans = `${name}/${version}`;
  if (build != null) {
    ans += `+${build}`;
  }
  if (hints != null) {
    for (const hint of hints) {
      ans += ` ${hint}`;
    }
  }
  return ans;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  authHeaders,
  combineHeaders,
  formatClientHeader,
  jsonHeaders
});
//# sourceMappingURL=headers.js.map
